import { render, staticRenderFns } from "./Advert.vue?vue&type=template&id=2b431864&scoped=true&"
import script from "./Advert.vue?vue&type=script&lang=js&"
export * from "./Advert.vue?vue&type=script&lang=js&"
import style0 from "./Advert.vue?vue&type=style&index=0&id=2b431864&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b431864",
  null
  
)

export default component.exports